// extracted by mini-css-extract-plugin
module.exports = {"container":"Cards_container__4yP9m","infected":"Cards_infected__32iNj","recovered":"Cards_recovered__25amM","deaths":"Cards_deaths__3ETzw"};